import { render, staticRenderFns } from "./ProcessDpo.vue?vue&type=template&id=2407e028&scoped=true&"
import script from "./ProcessDpo.vue?vue&type=script&lang=js&"
export * from "./ProcessDpo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407e028",
  null
  
)

export default component.exports